import DatePickerContainer from './DatePickerContainer';

export default DatePickerContainer;
